import React from 'react';
import Flexbox from 'flexbox-react';
import { inject, observer } from 'mobx-react';
import { Button, Classes, Collapse, Intent, Switch } from '@blueprintjs/core';

@inject('StoreTemplateActions', 'StoreTemplateStore', 'ToastStore')
@observer
export default class StoreTemplateEditPrivacy extends React.Component {
  constructor(props) {
    super(props);

    this.state = { isSubmitting: false, isOpen: false };
  }

  toggleOpen() {
    this.setState({
      isOpen: !this.state.isOpen,
    });
  }

  toggleLoading = () => {
    this.setState({
      isSubmitting: !this.state.isSubmitting,
    });
  };

  handleSubmit(e) {
    e.preventDefault();
    if (this.props.StoreTemplateStore.activeStoreTemplate.imageFileName.length === 0) {
      this.props.ToastStore.showToast(I18n.t('js.please_add_an_image_to_the_template_before_publishing'), 'danger');
    } else {
      this.toggleLoading();
      const newObj = {
        id: this.props.StoreTemplateStore.newStoreTemplate.id,
        status: this.props.StoreTemplateStore.newStoreTemplate.status,
      };
      this.props.StoreTemplateActions.changeStoreTemplate(newObj)
        .then(response => {
          this.props.StoreTemplateStore.addStoreTemplate(response.data);
          this.props.StoreTemplateStore.setActiveStoreTemplate(response.data.id);
          this.toggleLoading();
          this.toggleOpen();
          if (response.data.status === 'live') {
            this.props.ToastStore.showToast(I18n.t('js.template_has_Been_set_to_live'), 'success');
          }
        })
        .catch(() => {
          this.toggleLoading();
        });
    }
  }

  handlePrivateStoreTemplateChange() {
    if (this.props.StoreTemplateStore.newStoreTemplate.status === 'draft') {
      this.props.StoreTemplateStore.updateNewStoreTemplate('live', 'status');
    } else {
      this.props.StoreTemplateStore.updateNewStoreTemplate('draft', 'status');
    }
  }

  handleCancel() {
    this.props.StoreTemplateStore.resetEditedStoreTemplate();
    this.toggleOpen();
  }

  render() {
    return (
      <Flexbox flexDirection="column" flexGrow={1} marginBottom="20px">
        <Flexbox flexDirection="row" justifyContent="space-between" flexGrow={1}>
          <Flexbox flexDirection="column">
            {/* Disable jsx-a11y lints as the close functionality is duplicated by the adjacent button */}
            {/* eslint-disable-next-line */}
            <h4 className={`${Classes.HEADING} bp3-cursor-pointer noselect`} onClick={() => this.toggleOpen()}>
              {I18n.t('js.status')}
            </h4>
            <p className="noselect">{I18n.t('js.template_status_text')}</p>
          </Flexbox>
          <Flexbox flexDirection="column">
            <Button
              text={this.state.isOpen ? I18n.t('js.close') : I18n.t('js.expand')}
              icon={this.state.isOpen ? 'chevron-up' : 'expand-all'}
              onClick={() => this.toggleOpen()}
            />
          </Flexbox>
        </Flexbox>
        <Collapse isOpen={this.state.isOpen}>
          <form onSubmit={this.handleSubmit.bind(this)}>
            <Flexbox flexDirection="column" marginBottom="10px">
              <Switch
                className="bp3-control-no-margin"
                checked={this.props.StoreTemplateStore.newStoreTemplate.status === 'live'}
                label={this.props.StoreTemplateStore.newStoreTemplate.status === 'live' ? I18n.t('js.live') : I18n.t('js.draft')}
                onChange={this.handlePrivateStoreTemplateChange.bind(this)}
              />
            </Flexbox>
            <Flexbox>
              <div>
                <Button
                  intent={Intent.PRIMARY}
                  type="submit"
                  text={I18n.t('js.save_changes')}
                  loading={this.state.isSubmitting}
                  icon="tick"
                />
                <Button className="push-10-l" icon="cross" text={I18n.t('js.cancel_changes')} onClick={this.handleCancel.bind(this)} />
              </div>
            </Flexbox>
          </form>
        </Collapse>
      </Flexbox>
    );
  }
}
